export default __webpack_public_path__ + "static/media/africa.6afa171a.svg";